import { Core } from "@faire/design-tokens";
import { exhaustiveSwitchWithDefault } from "@faire/web--source/common/exhaustiveSwitchWithDefault";
import { hasDuplicateLanguages } from "@faire/web--source/common/localization/languageOptions";
import { ILanguageSelectorProps } from "@faire/web--source/ui/LanguageSelector/common";
import { LanguageDropdown } from "@faire/web--source/ui/LanguageSelector/LanguageDropdown";
import { useMemo } from "react";
import * as React from "react";
import styled, { css } from "styled-components";

export const LanguageSelectorDropdown = (
  props: ILanguageSelectorProps & { className?: string }
) => {
  const availableLocalesHasDuplicateLanguages = useMemo(() => {
    return hasDuplicateLanguages(props.availableLocales);
  }, [props.availableLocales]);

  return (
    <OuterDropdownWrapper
      $position={props.position ?? "downRight"}
      $showFullLocale={availableLocalesHasDuplicateLanguages}
      className={props.className}
    >
      <DropdownWrapper>
        <LanguageDropdown {...props} eventName="web-view-language-selector" />
      </DropdownWrapper>
    </OuterDropdownWrapper>
  );
};

type OuterDropdownWrapperProps = {
  $showFullLocale?: boolean;
  $position: "up" | "downRight" | "downLeft";
};

const getPositionStyles = (props: OuterDropdownWrapperProps) => {
  const { $position } = props;
  switch ($position) {
    case "downLeft":
      return css`
        top: 100%;
        right: 11px;
      `;
    case "up":
      return css`
        right: 11px;
        bottom: 100%;
      `;
    case "downRight":
      return css`
        top: 100%;
        left: 12px;
      `;
    default:
      return exhaustiveSwitchWithDefault(css`
        top: 100%;
        left: 12px;
      `)($position);
  }
};

const getWidth = (props: OuterDropdownWrapperProps) => {
  if (props.$showFullLocale) {
    return "170px";
  } else {
    return "142px";
  }
};

const OuterDropdownWrapper = styled.div<OuterDropdownWrapperProps>`
  position: absolute;
  width: ${(props) => getWidth(props)};
  background: white;
  border: 1px solid ${Core.border.muted};
  box-shadow: 0 1px 1px ${Core.surface.subdued};
  z-index: 2;
  ${(props) => getPositionStyles(props)};
`;

const DropdownWrapper = styled.div`
  padding: 24px 16px 0 16px;
`;
